module.exports = __webpack_public_path__ + "img/s-dagger.5f33dccd.svg";